var app = angular.module('leonardo');

var LayoutMain = function($window) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      scope.layoutMainOnWindowResize = function() {
        var height = angular.element($window).height();
        height -= element.find('.zone-header').outerHeight();
        element.find('> .wrapper-columns').css('min-height', height);
      };
      scope.layoutMainOnWindowResize();

      angular.element($window).resize(function() {
        scope.layoutMainOnWindowResize();
      });
    }
  };
};

app.directive('layoutMain', ['$window', LayoutMain]);
